export default __webpack_public_path__ + "static/media/logo6.431e513e.svg";